module.exports = __webpack_public_path__ + "static/img/ccod9.594fd21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccod9.png
// module id = /uF0
// module chunks = 0